/**
* Global settings/constants
*/
let urlsForDevelopment: any = {
	serviceName: "https://localhost:44325/api/",
	//login:"https://localhost:44325/api",
    facebookAppId: "1711347802443688"
};

let urlsForProduction: any = {
	serviceName: "/api/",
	//login:"'https://traken.azurewebsites.net/api",
    facebookAppId: "1710781912500277"
};


let serviceConfig: any;
if (window.location.hostname === 'localhost') {
    serviceConfig = urlsForDevelopment;
}
else {
    serviceConfig = urlsForProduction;
}


export default serviceConfig;